module.exports = __webpack_public_path__ + "static/media/ic_text2pay.7cbb248e.svg";